import { ProjectSettings } from '../interfaces/projectSettings';
import { projectSettingsSlice } from '../reducers/projectSettingsSlice';
import { getStore } from '../store';

type projectSettingsType = 'projectSettings/setProjectSettings';

export const projectSettingsProvider = (): {
  setProjectSettings: (projectSettings: ProjectSettings) => { payload: ProjectSettings; type: projectSettingsType };
} => {
  const { dispatch } = getStore();
  const { setProjectSettings } = projectSettingsSlice.actions;
  return {
    setProjectSettings: (projectSettings: ProjectSettings): { payload: ProjectSettings; type: projectSettingsType } =>
      dispatch(setProjectSettings(projectSettings)),
  };
};
